import DisableModeling from './DisableModeling';

export default {
  __init__: [
    'disableModeling'
  ],
  disableModeling: [ 'type', DisableModeling ]
};